"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.DEFAULT_MAX_WIDTH_TOOLTIP = exports.escapeRegExpString = void 0;
const escapeRegExpString = (string) => string.replace(/[\\^$.|?*{}+()[\]]/g, '\\$&');
exports.escapeRegExpString = escapeRegExpString;
exports.DEFAULT_MAX_WIDTH_TOOLTIP = '720px';
//# sourceMappingURL=helpers.js.map